
const styles = theme => ({
  root: {
    margin:"0 0 10px 0"
  },
  button: {
    textTransform: "initial",
    fontSize:10,
    height: 40,
    minWidth:150,
    width:"100%",
  },
  moreButton:{
    minWidth:5,
    fontSize:12,
  },
  input: {
    display: 'none',
  },
});

export default styles;